import { format, addDays, subDays } from "date-fns";

// Parse the filename to extract date and time
// Example: AktuellesBildistvom01_01_2025__08_05Uhr.jpg
export const parseFilename = (filename) => {
  // Extract the date and time part from the filename
  const match = filename.match(/vom(\d{2}_\d{2}_\d{4})__(\d{2}_\d{2})Uhr/);

  if (!match) return null;

  const [, datePart, timePart] = match;
  const [day, month, year] = datePart.split("_");
  const [hour, minute] = timePart.split("_");

  return {
    date: `${day}_${month}_${year}`,
    time: `${hour}_${minute}`,
    dateObj: new Date(`${year}-${month}-${day}T${hour}:${minute}:00`),
    formattedDate: `${day}.${month}.${year}`,
    formattedTime: `${hour}:${minute}`,
  };
};

// Format date for display
export const formatDate = (date) => {
  return format(date, "dd.MM.yyyy");
};

// Format date for filename
export const formatDateForFilename = (date) => {
  return format(date, "dd_MM_yyyy");
};

// Get previous day
export const getPreviousDay = (date) => {
  return subDays(date, 1);
};

// Get next day
export const getNextDay = (date) => {
  return addDays(date, 1);
};

// Get today's date in the format used in filenames
export const getTodayForFilename = () => {
  return formatDateForFilename(new Date());
};

// Sort images by date and time (newest first)
export const sortImagesByDateTime = (images) => {
  return [...images].sort((a, b) => {
    const dateA = parseFilename(a.name)?.dateObj || new Date(0);
    const dateB = parseFilename(b.name)?.dateObj || new Date(0);
    return dateB - dateA;
  });
};

// Format timestamp in German timezone for display
export const formatTimestampGerman = (
  timestamp,
  formatString = "dd.MM.yyyy HH:mm"
) => {
  if (!timestamp) return "Unknown time";

  try {
    // The timestamps are already stored in German local time, so just format them directly
    // without timezone conversion (they're not actually UTC despite being stored as such)
    return format(new Date(timestamp), formatString);
  } catch (error) {
    console.error("Error formatting timestamp:", error);
    return "Invalid time";
  }
};

// Format time only in German timezone (HH:mm)
export const formatTimeGerman = (timestamp) => {
  return formatTimestampGerman(timestamp, "HH:mm");
};

// Format full date and time in German timezone (DD.MM.YYYY HH:MM)
export const formatDateTimeGerman = (timestamp) => {
  return formatTimestampGerman(timestamp, "dd.MM.yyyy HH:mm");
};
